import React from 'react';

import { Placement } from '../constants';
import { ModalContainer } from '../ModalContainer/ModalContainer';
import type { BaseModalProps } from '../types';
import { Size } from '../types';
import Content from './components/Content/Content';
import Footer from './components/Footer/Footer';
import Header from './components/Header/Header';
import { CloseIconWrapper, StyledCloseIcon, Wrapper } from './BaseModal.styled';

const BaseModal = ({
  dataCy,
  width,
  height,
  minHeight,
  parentElement = document.body,
  close,
  children,
  focusTrapOptions = { initialFocus: false, returnFocusOnDeactivate: false },
  closeButtonLabel,
  placement = Placement.CENTER,
  ...rest
}: BaseModalProps) => {
  const handleCloseIconClick = () => close?.();

  const handleCloseIconKeyDown = (event: React.KeyboardEvent) => {
    if (event.key !== 'Enter') {
      return;
    }

    close?.();
  };

  return (
    <ModalContainer
      dataCy={dataCy}
      width={width}
      height={height}
      minHeight={minHeight}
      parentElement={parentElement}
      close={close}
      focusTrapOptions={focusTrapOptions}
      placement={placement}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
    >
      <Wrapper>
        {close && (
          <CloseIconWrapper>
            <StyledCloseIcon
              aria-label={closeButtonLabel}
              role="button"
              data-cy="closeModal"
              tabIndex={0}
              onKeyDown={handleCloseIconKeyDown}
              onClick={handleCloseIconClick}
            />
          </CloseIconWrapper>
        )}
        {children}
      </Wrapper>
    </ModalContainer>
  );
};

BaseModal.Size = Size;
BaseModal.Placement = Placement;
BaseModal.Header = Header;
BaseModal.Content = Content;
BaseModal.Footer = Footer;

export default BaseModal;
